import { baseNetworkRules } from "./NetworkValidators";

export const updateNetworkValidationRules = () => ({
    ...baseNetworkRules,
});

